export enum CaseBrokerStatuses {
  CREDIT_DECISION = 'Credit Decision',
  AFFORDABILITY = 'Affordability',
  PACKAGING = 'Packaging',
  AT_LENDER = 'Underwriting',
  OFFER = 'Offer',
  COMPLETION = 'Completion',
  WITHDRAWN = 'Withdrawn',
  REJECTED = 'Rejected',
  COMPLETED = 'Complete',
}

export enum CaseStatuses {
  WITH_BROKER = 'WithBroker',
  WITH_LENDER = 'WithLender',
  WITHDRAWN = 'Withdrawn',
  REJECTED = 'Rejected',
  COMPLETED = 'Complete',
}

export type Case = {
  id: string,
  reference: string,
  applicantNames: string,
  securityAddressPostCode: string,
  brokerStatus: CaseBrokerStatuses,
  status: CaseStatuses,
  brokerageName: string,
  brokerageId: string,
  brokerAssignedToId: string,
  brokerAssignedToName: string,
  isCurrentBroker: boolean,
  underwriterAssignedToName: string,
  totalTasksOutstanding: number,
  lastUpdated: string,
  rejectionReason: string,
  withdrawalReason: string,
  otherWithdrawalDetail: string,
  errors?: Record<string, string[]>,
}
